// extracted by mini-css-extract-plugin
export default {"root":"Header_root__1-IKd","inner":"Header_inner__ImH5N","buttons":"Header_buttons__6jkbd","username":"Header_username__Bc0UL","company":"Header_company__AqCQY"};